export default __webpack_public_path__ + "static/3-77a2069ab5d3355db92fb6597ae4100d.jpg";